<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-primary mb-0 hover-cursor">&nbsp;Lessor</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="card-title mb-4">Lessor </h5>
                <div class="search-table container-fluid">
                  <div class="row">
                    <div class="col-lg-4 col-sm mobile-div">
                      Lessor Name
                      <multiselect v-model="searchLessor" :options="selectLessorSearch" label="lessorName" :allow-empty="false" select-label="" deselect-label="" placeholder="Lessor" track-by="lessorName"></multiselect>
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                      <br>
                      <button class="btn btn-primary" @click="searchData"> Search </button>
                    </div>
                  </div>
                </div>
                <button class="btn btn-sm btn-primary mb-1" @click="openModal('Add')"> Add </button>
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th>Lessor Name</th>
                      <th>Lessor Point</th>
                      <th>On Renting (Qty)</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable == false && totalData == 0">
                      <td colspan="5" class="text-center"> Data not available </td>
                    </tr>
                    <tr v-else-if="loadingTable == true">
                      <td colspan="5" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    <tr v-for="(data, index) in dataLessor" :key="index" v-else>
                      <td>{{ data.lessorName }}</td>
                      <td>{{ data.pointName }}</td>
                      <td>{{ data.Qty }}</td>
                      <td><button class="btn btn-primary btn-sm" @click="toDetail(data.pointId)"> Detail </button></td>
                    </tr>
                  </tbody>
                </table>
                <div id="wrapperr">
                  <div id="c1">
                    <div class="alignLeft total-data">
                      Total Data {{ totalData }} 
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>></li></a>
                      </ul>
                    </div>
                  </div>
                </div>​
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <!-- modaladdlessor -->
      <div class="modal fade" id="modalAdd" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Add New Lessor </h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="one-line">
                        <label class="ol-label"> Lessor Name </label>
                        <label class="ol-titik2">:</label>
                        <multiselect v-model="addLessor" :options="selectLessor" label="lessorName" :allow-empty="false" deselect-label="" placeholder="Lessor"></multiselect>
                    </div>
                    <div class="one-line" v-if="addLessor.lessorId == 'other'">
                        <label class="ol-label"> New Lessor </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="name" class="form-control form-control-sm" v-model="addNewLessorName" placeholder="">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Supplier Name</label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="name" class="form-control form-control-sm" v-model="addSupplierName" placeholder="">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Supplier Address </label>
                        <label class="ol-titik2">:</label>
                        <textarea class="form-control form-control-sm" v-model="addSupplierAddress"> </textarea>
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Supplier Phone </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="phone_number" class="form-control form-control-sm"  v-model="addSupplierPhone" @keypress="isNumber($event)" placeholder="">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="addNewLessor" v-if="loadingButtonAdd == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endmodal -->
    </div>
  </div>
</template>

<script>
import SideBar from '../SideBar'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
export default {
  name: 'ResolutionCenterPage',
  components:{
    SideBar,
    Multiselect
  },
  data () {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      admin:"",
      adminId:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      dataLessor: [],
      totalPage:0,
      totalData:0,
      currentPage:1,
      orderId:"",
      companyName:"",
      statusOrder:"",
      loadingTable:true,
      loadingButtonAdd:false,
      addCompanyName:'',
      addProvince:'',
      addDistrict:'',
      addCity:'',
      addCompanyVillage:'',
      addAddress:'',
      addPhoneNumber:'',
      province:[],
      kabkot:[],
      kecamatan:[],
      addLessor:{
        lessorId:'',
        lessorName:'Choose Lessor'
      },
      selectLessor:[],
      selectLessorSearch:[],
      addNewLessorName:'',
      addSupplierName:'',
      addSupplierAddress:'',
      addSupplierPhone:'',
      searchLessor:{
        lessorId:'All',
        lessorName:'All'
      },
    }
  },
  methods: {
    sendLog(x){
          var today = new Date();
          var month = today.getMonth()+1
          if (month < 10) {
              month = '0'+month
          }
          var dateDay = today.getDate()
          if (dateDay < 10) {
              dateDay = '0'+dateDay
          }
          var hours = today.getHours()
          if (hours < 10) {
              hours = '0'+hours
          }
          var minutes = today.getMinutes()
          if (minutes < 10) {
              minutes = '0'+minutes
          }
          var second = today.getSeconds()
          if (second < 10) {
              second = '0'+second
          }
          var date = today.getFullYear()+'-'+month+'-'+dateDay;
          var time = hours + ":" + minutes + ":" + second;
          var dateTime = date+' '+time;
          var admin = this.admin
          var command = 'add-logs'
          // var productName = this.productNameChoose
          
          this.$http.post(process.env.LOG_URL+"/lessor/"+x,{
              codeLogs: 40,
              params: [],
          },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
          })
          .then(response => {
          })
          .catch(error => {
              console.log(error)
          })
    },
    isNumber: function(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();;
          } else {
            return true;
          }
    },
    addNewLessor(){
      if (this.addLessor.lessorId== 'other') {
        if (this.addNewLessorName == '') {
            swal("Sorry", "New lessor must be fill", "error", {
              button: "Ok",
            })
        }else if (this.addSupplierName == '') {
            swal("Sorry", "Supplier name must be fill", "error", {
              button: "Ok",
            })
        }else if (this.addSupplierAddress == '') {
            swal("Sorry", "Supplier address must be fill", "error", {
              button: "Ok",
            })
        }else if (this.addSupplierPhone == '') {
            swal("Sorry", "Supplier phone must be fill", "error", {
              button: "Ok",
            })
        }else{
            this.loadingButtonAdd = true
            this.$http.post(process.env.ADD_LESSOR,{
              lessorId: this.addLessor.lessorId,
              newLessor: this.addNewLessorName !== null ? this.addNewLessorName.replace(this.spaceRegex, ' ') : this.addNewLessorName,
              supplierName: this.addSupplierName !== null ? this.addSupplierName.replace(this.spaceRegex, ' ') : this.addSupplierName,
              supplierAddress: this.addSupplierAddress !== null ? this.addSupplierAddress.replace(this.spaceRegex, ' ') : this.addSupplierAddress,
              supplierPhone: this.addSupplierPhone !== null ? this.addSupplierPhone.replace(this.spaceRegex, ' ') : this.addSupplierPhone
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
              if (response.data.status == 400) {
                  swal("Sorry", response.data.message , "error", {
                    button: "Ok",
                  })
                  $('#modalAdd').modal('hide')
              }else if (response.data.status == 201) {
                  swal("Sorry", response.data.message , "error", {
                    button: "Ok",
                  })
              }else if (response.data.status == 200) {
                  swal("Success", response.data.message , "success", {
                    button: "Ok",
                  })
                  this.sendLog(response.data.content)
                  this.addLessor = ({
                    lessorId:'',
                    lessorName:'Choose Lessor'
                  })
                  this.addNewLessorName = ''
                  this.addSupplierName = ''
                  this.addSupplierAddress = ''
                  this.addSupplierPhone = ''
                  $('#modalAdd').modal('hide')
              }
              this.getData()
              this.loadingButtonAdd = false
            })
            .catch(error => {
              swal("Sorry", error.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            }) 
        }
      }else{
        if (this.addLessor.lessorId == '') {
            swal("Sorry", "Lessor must be choose", "error", {
              button: "Ok",
            })
        }else if (this.addSupplierName == '') {
            swal("Sorry", "Supplier name must be fill", "error", {
              button: "Ok",
            })
        }else if (this.addSupplierAddress == '') {
            swal("Sorry", "Supplier address must be fill", "error", {
              button: "Ok",
            })
        }else if (this.addSupplierPhone == '') {
            swal("Sorry", "Supplier phone must be fill", "error", {
              button: "Ok",
            })
        }else{
            this.loadingButtonAdd = true
            this.$http.post(process.env.ADD_LESSOR,{
              lessorId: this.addLessor.lessorId,
              newLessor: this.addNewLessorName !== null ? this.addNewLessorName.replace(this.spaceRegex, ' ') : this.addNewLessorName,
              supplierName: this.addSupplierName !== null ? this.addSupplierName.replace(this.spaceRegex, ' ') : this.addSupplierName,
              supplierAddress: this.addSupplierAddress !== null ? this.addSupplierAddress.replace(this.spaceRegex, ' ') : this.addSupplierAddress,
              supplierPhone: this.addSupplierPhone !== null ? this.addSupplierPhone.replace(this.spaceRegex, ' ') : this.addSupplierPhone
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
              if (response.data.status == 400) {
                  swal("Sorry", response.data.message , "error", {
                    button: "Ok",
                  })
                  $('#modalAdd').modal('hide')
              }else if (response.data.status == 201) {
                  swal("Sorry", response.data.message , "error", {
                    button: "Ok",
                  })
              }else if (response.data.status == 200) {
                  swal("Success", response.data.message , "success", {
                    button: "Ok",
                  })
                  this.sendLog(response.data.content)
                  this.addLessor = ({
                    lessorId:'',
                    lessorName:'Choose Lessor'
                  })
                  this.addNewLessorName = ''
                  this.addSupplierName = ''
                  this.addSupplierAddress = ''
                  this.addSupplierPhone = ''
                  $('#modalAdd').modal('hide')
              }
              this.getData()
              this.loadingButtonAdd = false
            })
            .catch(error => {
              swal("Sorry", error.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            }) 
        }
      }
    },
    getKabkot(x){
        this.$http.post(process.env.API_GET_KABKOT, {
            provinceId: this.addProvince.provinceId,
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
            if (response.data.status == 200) {
                this.kabkot = response.data.content
                if (x == 'ada') {
                    this.addDistrict = ''
                    this.addCity = ''
                }
            }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getKecamatan(x) {
        this.$http.post(process.env.API_GET_KECAMATAN, {
            kabKotId: this.addDistrict.kabKotId,
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
            if (response.data.status == 200) {
                this.kecamatan = response.data.content
                if (x == 'ada') {
                    this.addCity = ''
                }
            }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    openModal(x) {
        $("#modal"+x).modal('show')
    },
    searchData(){
      this.$router.push({path:'/partnership/lessor/search', query: {
            lessorId: this.searchLessor.lessorId,
            lessorName: this.searchLessor.lessorName,
            page:1
          }
      })
      this.loadingTable = true
      this.getData()
    },
    toDataPage(pagePost){
      this.loadingTable = true
      this.$router.push({path:'/partnership/lessor/search', query: {
            lessorId: this.searchLessor.lessorId,
            lessorName: this.searchLessor.lessorName,
            page:pagePost
          }
      })
      this.getData()
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewDashboard = true
        }
        if( this.permission[i] == "2.1"){
          this.viewOrder = true
        }
        if( this.permission[i] == "2.2"){
          this.editOrder = true
        }
        if( this.permission[i] == '3.1'){
          this.viewReturn = true
        }
        if( this.permission[i] == '3.2'){
          this.editReturn = true
        }
        if( this.permission[i] == '4.1'){
          this.viewProduct = true
        }
        if( this.permission[i] == '4.2'){
          this.editProduct = true
        }
        if( this.permission[i] == '5.1'){
          this.viewPairing = true
        }
        if( this.permission[i] == '5.2'){
          this.editPairing = true
        }
        if( this.permission[i] == '6'){
          this.viewReconcile = true
        }
        if( this.permission[i] == '7.1'){
          this.viewResolution = true
        }
        if( this.permission[i] == '7.2'){
          this.editResolution = true
        }
        if( this.permission[i] == '8.1'){
          this.viewLessor = true
        }
        if( this.permission[i] == '8.2'){
          this.editLessor = true
        }
        if( this.permission[i] == '9.1'){
          this.viewLessee = true
        }
        if( this.permission[i] == '9.2'){
          this.editLessee = true
        }
        if( this.permission[i] == '10'){
          this.viewEmployee = true
        }
      }
      if (this.viewLessor == false) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    toDetail(id){
      this.$router.push('/partnership/lessor/renting/detail/' + id)
    },
    getData(){
      this.loadingTable = true
      this.searchLessor.lessorId = this.$route.query.lessorId
      this.searchLessor.lessorName = this.$route.query.lessorName
      this.currentPage = parseInt(this.$route.query.page)
      this.$http.post(process.env.SEARCH_LESSOR,{
        lessorId: this.searchLessor.lessorId,
        page: this.$route.query.page
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        this.dataLessor = response.data.content.data
        this.totalPage = response.data.content.totalPage
        this.totalData = response.data.content.totalData
        this.currentPage = response.data.content.currentPage
        this.loadingTable = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })

      this.$http.get(process.env.GET_ALL_LESSOR
      ,{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
          if (response.data.status == 200) {
              this.selectLessorSearch=[]
              this.selectLessorSearch.push({
                lessorId:'All',
                lessorName:'All'
              })
              for (var i = 0; i < response.data.content.length; i++) {
                this.selectLessorSearch.push({
                  lessorId: response.data.content[i].lessorId,
                  lessorName: response.data.content[i].lessorName
                }) 
              }
              this.selectLessor=[]
              this.selectLessor = response.data.content
              this.selectLessor.push({
                lessorId:'other',
                lessorName:'Other'
              })
          }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    }
  },
  created(){
    this.cekPermission()
    this.getData()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.one-line{
    display: flex;
    margin: 5px 0px;
}
.one-line .ol-titik2{
  width: 15px;
  margin: 2px 0px;
}
.one-line .ol-label{
  width: 188px;
  margin: 2px 0px;
}

.pagination{
padding: 0px 0;
}

.pagination ul{
margin: 0;
padding: 0;
list-style-type: none;
}

.pagination a{
display: inline-block;
padding: 1px 6px;
color: #222;
}

.p8 a{
background-color: #2797FB;
/*margin: auto 5px;*/
color: #fff;
/*font-weight: bold;*/
border: 1px solid #2797FB;
}

.p8 a:hover{
text-decoration: none;
}
.p8 a.page:hover{
text-decoration: none;
color: #fff;
}

.p8 .is-active{
background-color: #fff;
color: #2797FB;
}

.alignleft {
float: left;
}
.alignright {
float: right;
}

.pagg{
display: inline-flex;
overflow:auto;
}

.total-data{
padding: 11px 0px;
font-size: 14px;
color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}

#c1{
 float:left;
}

#c2{
float: right;  
}

.search-table{
padding-bottom: 7px;
margin-top: -5px;
margin-left: -15px;
}
.active{
color: #2797FB;
}
.right-dropdown{
margin-left: 7px;
}
.account-div{
margin: 2px 2px;
}
.right-arrow{
margin-left: auto;
}
.brand-logo{
width: 120px;
}
.menu-title{
margin-left: 1.125rem;
}
.menu-title-order{
margin-left: 1.95rem;
}
.menu-title-payment{
margin-left: 1.525rem;
}

ul {
list-style-type: none;
margin: 0;
padding: 0;
/*width: 200px;*/
/*background-color: #f1f1f1;*/
}

li.sidebar a {
display: block;
color: #000;
padding: 8px 63px;
text-decoration: none;
}

li a.active {
background-color: #4CAF50;
color: white;
}

li a:hover:not(.active) {
background-color: #2797FB;
color: white;
}
.nav-side-menu {
overflow: auto;
font-family: verdana;
font-size: 12px;
font-weight: 200;
background-color: #2e353d;
position: fixed;
top: 0px;
width: 300px;
height: 100%;
color: #e1ffff;
}
.nav-side-menu .brand {
background-color: #23282e;
line-height: 50px;
display: block;
text-align: center;
font-size: 14px;
}
.nav-side-menu .toggle-btn {
display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
list-style: none;
padding: 0px;
margin: 0px;
line-height: 35px;
cursor: pointer;
}
 .nav-side-menu ul :not(collapsed) .arrow:before,
 .nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Partnership/LessorPageSearch.vue